import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { HeadingDisplay, Grid } from '@warrenbrasil/nebraska-web';
import { AllocationChartLegend } from '@/modules/wealth/components/AllocationChartLegend';
import { BarChart } from '@/modules/common/components/charts/v2/BarChart';
import { Money } from '@/modules/common/components/Money';

import { IAppliedChart } from '@/modules/wealth/services/portfolio-allocation';

interface Props {
  appliedChart: IAppliedChart;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppliedChart',
  props: {
    appliedChart: null
  },
  setup(__props: any) {

const { appliedChart } = __props as {
  appliedChart: IAppliedChart;
};



const headingData = ref({
  head: 'Patrimônio da carteira',
  value: appliedChart.totalBalance.formatted
});

const legendData = computed(() => {
  return appliedChart.data.map(item => {
    return {
      color: item.color,
      leftTitle: item.type,
      leftSubtitle: `${item.percent.formatted} ${item.sufix}`,
      rightTitle: item.balance.formatted,
      rightSubtitle: ''
    };
  });
});

const series = computed(() => {
  return [
    {
      type: 'column',
      name: 'Atual',
      data: appliedChart.data.map(item => {
        return {
          y: item.percent.value,
          custom: {
            head: item.type,
            value: item.balance.formatted
          }
        };
      }),
      colorByPoint: true,
      colors: appliedChart.data.map(item => item.color),
      pointPadding: 0,
      groupPadding: 0.07,
      maxPointWidth: 125,
      borderRadius: 5,
      borderWidth: 0,
      inactiveOtherPoints: true,
      cursor: 'pointer',
      dataLabels: {
        enabled: true,
        format: 'A',
        style: {
          color: NebraskaColors.elementPrimary,
          fontSize: '13px',
          fontFamily: 'var(--font-text)'
        }
      },
      point: {
        events: {
          mouseOver: function () {
            headingData.value = this.custom;
          },
          mouseOut: function () {
            headingData.value = {
              head: 'Patrimônio da carteira',
              value: appliedChart.totalBalance.formatted
            };
          }
        }
      },
      states: { hover: { color: '', borderColor: '' } }
    }
  ];
});

return { __sfc: true,headingData, legendData, series, HeadingDisplay, Grid, AllocationChartLegend, BarChart, Money }
}

})